<template>
  <div class="modal fade" id="productModal" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Product</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body">
          <div class="mb-3">
            <label>Product Name</label>
            <input type="text" class="form-control" v-model="product.name" />
          </div>

          <div class="mb-3">
            <label>Purchase Price</label>
            <input type="number" class="form-control" v-model.number="product.purchasePrice" min="0" step="0.01"
              placeholder="Enter purchase price" />
          </div>

          <div class="mb-3">
            <label>Selling Price</label>
            <input type="number" class="form-control" v-model.number="product.sellingPrice" min="0" step="0.01"
              placeholder="Enter selling price" />
          </div>
          <div class="mb-3">
            <label>Category</label>
            <select class="form-control" v-model.number="product.categoryId" @change="populateAttributes">
              <option disabled value="">-- Select Category --</option>
              <option v-for="c in categories" :key="c.id" :value="c.id">{{ c.name }}</option>
            </select>
            <button class="btn btn-link p-0" @click.prevent="$emit('open-category-modal')">+ Add Category</button>
          </div>

          <div class="mb-3" v-if="attributeInputs.length">
            <label>Attributes</label>
            <div v-for="(attr, index) in attributeInputs" :key="index" class="mb-2">
              <label class="form-label">{{ attr.name }}</label>
              <input :type="attr.type === 'number' ? 'number' : 'text'" class="form-control" v-model="attr.value" />
            </div>
          </div>

          <div class="mb-3">
            <label>Product Images</label>
            <input type="file" multiple class="form-control" @change="handleImageChange" />
            <div class="d-flex flex-wrap gap-2 mt-2">
              <div v-for="(image, index) in product.images" :key="index" class="position-relative">
                <img :src="image.preview" class="img-thumbnail"
                  style="width: 100px; height: 100px; object-fit: cover;" />
                <button @click="removeImage(index)"
                  class="btn btn-danger btn-sm position-absolute top-0 end-0 m-1">&times;</button>
              </div>
            </div>
          </div>

        </div>

        <div class="modal-footer">
          <button class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button class="btn btn-success" @click="saveProduct">Save Product</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as bootstrap from 'bootstrap';
import { productApi } from '@/api/productApi';
import notify from '@/utils/swal.js';

export default {
  props: ['categories'],
  data() {
    return {
      product: {
        name: '',
        purchasePrice: 0,
        sellingPrice: 0,
        categoryId: '',
        images: [] // To store File objects and previews
      },
      attributeInputs: [],
      modalInstance: null
    };
  },
  mounted() {
    this.modalInstance = new bootstrap.Modal(document.getElementById('productModal'));
  },
  methods: {
    showModal() {
      // Reset product state when showing modal
      this.product = {
        name: '',
        purchasePrice: 0,
        sellingPrice: 0,
        categoryId: '',
        images: []
      };
      this.attributeInputs = [];
      this.modalInstance.show();
    },
    populateAttributes() {
      const selected = this.categories.find(c => c.id === this.product.categoryId);
      this.attributeInputs = selected?.attributes.map(attr => ({
        categoryAttributeId: attr.id,
        name: attr.name,
        type: attr.type,
        value: ''
      })) || [];
    },
    handleImageChange(event) {
      const files = event.target.files;
      if (files) {
        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          this.product.images.push({
            file: file,
            preview: URL.createObjectURL(file)
          });
        }
      }
    },
    removeImage(index) {
      // Clean up the object URL to free up memory
      URL.revokeObjectURL(this.product.images[index].preview);
      this.product.images.splice(index, 1);
    },
    async saveProduct() {
      if (!this.product.name || !this.product.categoryId) {
        notify.warning("Product name and category are required");
        return;
      }
      if (this.product.sellingPrice < 0 || this.product.purchasePrice < 0) {
        notify.warning("Prices must be 0 or greater");
        return;
      }

      const formData = new FormData();

      // Append simple product details as individual form fields.
      formData.append('name', this.product.name);
      formData.append('sellingPrice', this.product.sellingPrice);
      formData.append('purchasePrice', this.product.purchasePrice);
      formData.append('stock', 0); // Always send a default value to avoid the null error
      formData.append('categoryId', this.product.categoryId);

      // Append each attribute as an individual form part using array notation.
      this.attributeInputs.forEach((attr, index) => {
        formData.append(`attributes[${index}].categoryAttributeId`, attr.categoryAttributeId);
        formData.append(`attributes[${index}].value`, attr.value);
      });

      // Append each image file individually.
      this.product.images.forEach((image) => {
        formData.append('images', image.file, image.file.name);
      });


      try {
        const res = await productApi.create(formData);
        this.$emit('product-added', res.data);
        this.modalInstance.hide();
        notify.success("Product saved successfully");
      } catch (error) {
        console.error('Failed to save product:', error);
        notify.error("Error saving product");
      }
    }
  }
};
</script>